import React, { useState }  from 'react'
import { Container, Row, Col, Card, Button, Collapse, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import redArrow from '../assets/images/red-arrow.svg'

function FAQ() {
  const [expandedCards, setExpandedCards] = useState({
    markets: false,
    apartments: false,
    resources: false,
    listings: false
  });

  const toggleCard = (card) => {
    setExpandedCards(prev => ({
      ...prev,
      [card]: !prev[card]
    }));
  };

  const cities = [
    ['Albuquerque', 'Aurora', 'Bend', 'Bowie', 'Charleston'],
    ['Alexandria', 'Austin', 'Birmingham', 'Brentwood', 'Charlotte'],
    ['Anchorage', 'Bakersfield', 'Boca Raton', 'Buffalo', 'Chattanooga'],
    ['Arlington', 'Baltimore', 'Boise real', 'Burlington', 'Chicago'],
    ['Ashburn', 'Baton Rouge', 'Boston', 'Cape Coral', 'Cincinnati'],
    ['Atlanta', 'Beaverton', 'Boulder', 'Chandler', 'Colorado Springs']
  ];

  const states = [
    ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California'],
    ['Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia'],
    ['Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa'],
    ['Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland']
  ];

  const markets = ['Fresno, CA', 'Los Angeles, CA', 'San Diego, CA', 'San Francisco, CA', 'Sacramento, CA'];
  const apartmentCities = ['New York, NY', 'Chicago, IL', 'Los Angeles, CA', 'Houston, TX', 'Phoenix, AZ'];
  const resources = ['Home Buying Guide', 'Mortgage Calculator', 'Market Trends', 'Property Values', 'School Ratings'];
  const newListings = ['California', 'Texas', 'Florida', 'New York', 'Arizona'];

  return (
    <>
     <div className="explore-result-locations common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>
           Frequently asked questions
          </h2>
          <p>
            With over a million agents from all the top brokerages, a local agent knows your market and can guide you through the process from start to finish
          </p>
        </div>
        <Accordion defaultActiveKey="0" >
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <h5>How to find a good real estate agent near me?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>To find a good real estate agent near you, use our search tools to filter agents by location, experience, reviews, and specialties. Read client testimonials and check their transaction history to ensure they match your needs.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h5>How to contact a real estate agent?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>You can contact a real estate agent directly through our platform by clicking the 'Contact Agent' button on their profile or listing page. Send messages, schedule tours, or request more information securely.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <h5>How do I leave a review for a real estate agent?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>After working with an agent, you can leave a review on their profile page. Share your experience to help other users make informed decisions and provide valuable feedback to the agent.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <h5>What is the difference between an agent and a broker?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>A real estate agent works under a broker and helps clients buy, sell, or rent properties. A broker has passed additional licensing requirements and can operate their own brokerage, supervise agents, and handle more complex transactions.</p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
     </div>
    </>
  )
}
export default FAQ